import { c as _c } from "react/compiler-runtime";
// Section heading — Stripe-style.
//
// Standard pattern across every section: optional eyebrow label (small,
// regular weight, brand-blue), heading (display-scale, medium, tight
// tracking), optional lead paragraph (body-lg, muted-foreground). Aligned
// left by default so body content beneath inherits the same column.
//
// Variants:
//   - default: eyebrow + heading + lead, all left-aligned
//   - centered: same content but centred + max-w-2xl mx-auto, used for the
//     mid-page sections (mission/vision, FAQ) where Stripe centres the
//     heading block above an asymmetric or wide content area.

import { cn } from '@/lib/ui/utils';
export interface SectionHeadingProps {
  /** Small label rendered above the heading in brand colour. Optional. */
  eyebrow?: string | undefined;
  /** Required heading text. */
  title: string;
  /** Optional lead paragraph below the heading. */
  lead?: string | undefined;
  /** ID applied to the rendered `h2` so the section can be anchor-linked. */
  headingId?: string | undefined;
  /** Centre the block + cap width to `max-w-2xl`. Defaults to `false`. */
  centered?: boolean | undefined;
  className?: string | undefined;
}
const EYEBROW_BASE = 'inline-block text-caption font-medium tracking-wide text-foreground-brand uppercase' as const;
export function SectionHeading(t0) {
  const $ = _c(15);
  const {
    eyebrow,
    title,
    lead,
    headingId,
    centered: t1,
    className
  } = t0;
  const centered = t1 === undefined ? false : t1;
  const t2 = centered ? "mx-auto max-w-2xl text-center" : "max-w-3xl";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("space-y-3", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== eyebrow) {
    t4 = eyebrow !== undefined ? <span className={EYEBROW_BASE}>{eyebrow}</span> : null;
    $[3] = eyebrow;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== headingId || $[6] !== title) {
    t5 = <h2 id={headingId} className="text-balance text-heading-lg leading-tight tracking-[-0.01em] text-foreground-primary md:text-display">{title}</h2>;
    $[5] = headingId;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== lead) {
    t6 = lead !== undefined ? <p className="text-body-lg leading-relaxed text-foreground-secondary">{lead}</p> : null;
    $[8] = lead;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <header className={t3}>{t4}{t5}{t6}</header>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}